import { render, staticRenderFns } from "./PromptBox.vue?vue&type=template&id=61db032f&"
import script from "./PromptBox.vue?vue&type=script&lang=js&"
export * from "./PromptBox.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/prompt-box.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports